/**
 * Медиа модели для экскурсии / контента (E15 / ФТ-8.1, ФТ-1.4).
 */

import { z } from "zod";
import { apiSuccessSchema } from "./envelope";
import { tourMediaTypeSchema } from "./wizard";

export const modelMediaItemSchema = z.object({
  id: z.string().uuid(),
  modelId: z.string().uuid(),
  fileId: z.string().uuid(),
  mediaType: tourMediaTypeSchema,
  sortOrder: z.number().int().min(0).max(100_000),
  originalName: z.string().nullable(),
  mimeType: z.string().nullable(),
  /** Условие показа; в админке видно, клиенту не отдаётся в tour. */
  displayCondition: z.string().nullable(),
});
export type ModelMediaItem = z.infer<typeof modelMediaItemSchema>;

export const modelMediaListResponseSchema = apiSuccessSchema(z.array(modelMediaItemSchema));
export const modelMediaItemResponseSchema = apiSuccessSchema(modelMediaItemSchema);

export const MODEL_MEDIA_ERROR_CODES = {
  MODEL_NOT_FOUND: "MODEL_MEDIA_MODEL_NOT_FOUND",
  NOT_FOUND: "MODEL_MEDIA_NOT_FOUND",
  FILE_REQUIRED: "MODEL_MEDIA_FILE_REQUIRED",
  INVALID_MEDIA_TYPE: "MODEL_MEDIA_INVALID_TYPE",
} as const;
export type ModelMediaErrorCode =
  (typeof MODEL_MEDIA_ERROR_CODES)[keyof typeof MODEL_MEDIA_ERROR_CODES];
